<template>
  <main>
    <AboutProjectBlock />
    <AboutChildrenBlock
      :customBackground="'about-children__wrapper--first-block'"
    />
    <AboutCategoryBlock />
    <AboutPrizeBlock />
    <AboutWorldContest
      :customBackground="'about-children__wrapper--second-block'"
    />
  </main>
</template>

<script>
import { Head } from '~/mixins/Head'
import { PageMixin } from '~/mixins/PageMixin'
import AboutProjectBlock from '~/components/AboutProjectBlock'
import AboutChildrenBlock from '~/components/AboutChildrenBlock'
import AboutCategoryBlock from '~/components/AboutCategoryBlock'
import AboutPrizeBlock from '~/components/AboutPrizeBlock'
import AboutWorldContest from '~/components/AboutWorldContest'

export default {
  computed: {
    metaObj() {
      return this.messages.about.meta
    }
  },
  mixins: [PageMixin, Head],
  components: {
    AboutProjectBlock,
    AboutChildrenBlock,
    AboutCategoryBlock,
    AboutPrizeBlock,
    AboutWorldContest
  },
  mounted() {
    this.fullUrl = window.location.href
  }
}
</script>



// WEBPACK FOOTER //
// pages/about.vue